import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3166504c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-arrow-right view-more-chevron",
  "aria-hidden": "true"
}, null, -1))

import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import RankingChart from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import type { RankingItem } from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import {
  ResponseHandlingService,
  RiskTerminalList,
} from '@/views/dashboard/response-manage/response-handle/service'
import { PermissionFe } from '@/services/service-permission.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'realtime-risk-terminal-ranking',
  setup(__props) {

const router = useRouter()
const injector = useReflectiveInjector([ResponseHandlingService])
const responseService = injector.get(ResponseHandlingService)

const loading = ref(false)
const chartData = ref<RankingItem[]>([])

/** 病毒 + 勒索 + 漏洞 + 基线 + 端口 五项合计（与响应中心终端列表列一致） */
function sumRiskFive (row: RiskTerminalList): number {
  return (
    (row.unhandled_risk_count ?? 0) +
    (row.ransomware_count ?? 0) +
    (row.leak_count ?? 0) +
    (row.substandard_count ?? 0) +
    (row.danger_port_count ?? 0)
  )
}

function goResponseHandle () {
  router.push({ path: '/dashboard/response-handle' })
}

async function load () {
  loading.value = true
  try {
    const res = await responseService.getTerminalRiskList({
      group_id: -1,
      device_id: '',
      page: 1,
      limit: 200,
      permission_names: [
        PermissionFe.port_control,
        PermissionFe.linux_base_auth,
        PermissionFe.ransomware_protect,
      ],
      risk_type: 0,
      login_status: 0,
      isolation_status: 0,
      system_type: 0,
    })
    const raw = res.risk_terminal_list || []
    chartData.value = raw
      .map((row) => ({
        name: row.computer_name || '--',
        department: row.user_mark || row.group_name || '',
        count: sumRiskFive(row),
        device_id: row.device_id,
      }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 5)
  } catch {
    chartData.value = []
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  void load()
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(RankingChart, {
    class: "realtime-risk-terminal-ranking",
    title: _ctx.$t('overviewZone.realtimeRiskTerminalRankTitle'),
    data: chartData.value,
    loading: loading.value,
    "show-time-range": false,
    "card-size": "second",
    unit: _ctx.$t('overviewZone.unitPiece'),
    "name-key": "name",
    "item-key-field": "device_id"
  }, {
    titleAfter: _withCtx(() => [
      _createVNode(_component_el_tag, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.rankTagTop5')), 1)
        ]),
        _: 1
      })
    ]),
    headerRight: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "text",
        size: "small",
        link: "",
        onClick: goResponseHandle
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('commonPage.viewAll')) + " ", 1),
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "data", "loading", "unit"]))
}
}

})